module.exports = __webpack_public_path__ + "static/src/content/images/us navy flag.2c9041d.png";


//////////////////
// WEBPACK FOOTER
// ./src/content/images/us navy flag.png
// module id = QUD3
// module chunks = 0